export const AD_ID = 'adsense1';
export const MID_AD_BANNER_MOBILE = 'mid-ad-banner-mobile';
export const MID_AD_TOWER = 'mid-ad-tower';
export const MID_AD_TOWER_2 = 'mid-ad-tower_2'; // for HA_ADS_SERP_RIGHTRAIL_300x600 variant 3
export const SERP_INLINE_ADS = [
    'serp-inline-1',
    'serp-inline-2',
    'serp-inline-3'
];
export const RIGHT_RAIL_AD_VIEWPORT_MIN_WIDTH = 1480;
export const RIGHT_RAIL_AD_XL_VIEWPORT_MIN_WIDTH = 1800;
export const DEFAULT_SCREEN_SIZE = 1366;
// Any IDs in this array will get its' pointer event remove when the map is moving
export const IFRAME_ADS = [AD_ID, MID_AD_TOWER, ...SERP_INLINE_ADS];
